declare global {
	interface Window {
		__REDUX_DEVTOOLS_EXTENSION_COMPOSE__: <F extends Function>(f: F) => F;
	}
}

import { createStore, compose, applyMiddleware } from 'redux';
import { createLogger } from 'redux-logger';
import { syncHistoryWithStore, routerMiddleware } from 'react-router-redux';
import { hashHistory } from 'react-router';
import thunk from 'redux-thunk';

import rootReducer, { StoreState } from '../reducers';
import setLocales from './setLocales';

// Enable Redux DevTools
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const reduxRouterMiddleware = routerMiddleware(hashHistory);

const middlewares = [
	thunk,
	reduxRouterMiddleware
];

if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test') {
	middlewares.push(createLogger());
}

const store = createStore<StoreState>(
	rootReducer,
	composeEnhancers(applyMiddleware(...middlewares))
);

setLocales(store);

export const history = syncHistoryWithStore(hashHistory, store);

export default store;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/store/index.ts